import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import VirtualMeeting from './icon-virtual-meeting.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <VirtualMeeting {...validProps} />;
}
SvgComponent.iconName = 'meetingVirtual';

/**
 * @deprecated This is a legacy icon
 */
export const VirtualMeetingIcon = svgIconWrapper(SvgComponent);
